/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */

export default {
    name: 'zt',
    data() {
        return {
            crumbsList:Object.freeze([{
                name:'专题',
                key:'zt'
            }]),
            data: {data: []}
        };
    },
    created() {
        this.getData();
    },
    methods: {
        // 获取列表的数据
        getData(pageInfo) {
            const params = pageInfo || {};
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.zt.index,
                params: params
            }).then((res) => {
                this.data = res.data;
            });
        },
        // 点击跳转详情
        handleToDetail(item) {
            this.$router.push({
                path: '/zt/detail',
                query: {
                    id: item.bh,
                    bt: item.bt,
                    fbsj: item.fbsj,
                    fbdw: item.fbdwTranslateText
                }
            });
        }
    }
};

